var _defs, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_profile",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_248",
    "data-name": "Ellipse 248",
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#d4e8dc"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_247",
    "data-name": "Ellipse 247",
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#d4e8dc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M158.846-39.051a45.031,45.031,0,0,1-3.43,4.2c-.819.665-19.474,6.569-22.436,10.546C129.3-19.364,127.786-8.4,127,1.041h83.355c-.79-9.439-2.3-20.4-5.985-25.347-2.961-3.977-21.617-9.881-22.436-10.546a45.054,45.054,0,0,1-3.43-4.2h-.179V-42.92a21.9,21.9,0,0,0,2.541-3.988,18.24,18.24,0,0,0,.963-4.507c3.073-1.41,3.446-6.324,3.575-9.078.057-1.218-.465-1.433-1.1-1.265a59.115,59.115,0,0,0,1.908-8.056c1.257-7.619-9.528-9.577-9.528-9.577-17.49-12.116-25.2,5.69-24.642,4.651a4.7,4.7,0,0,1,2.123-1.652c-1.509,1.407-3.492,7.4-3.074,8.231.232.456,1.333,3.686,2.273,6.487-.739-.291-1.414-.195-1.349,1.182.13,2.756.5,7.672,3.578,9.08a18.208,18.208,0,0,0,.964,4.506,21.881,21.881,0,0,0,2.469,3.9v3.96Z",
    transform: "translate(-119.444 94.96)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfile);
export default __webpack_public_path__ + "static/media/ic_profile.c9dd35a8.svg";
export { ForwardRef as ReactComponent };